module.exports = __webpack_public_path__ + "static/aplicaciones-9ce2e0b0e1f7eea74cd8a6c4a4a0c8b1.svg";